import React from 'react'
import { Button, Container } from 'reactstrap'
import { useTranslation } from 'react-i18next'

import history from '../helpers/History'

const FourOFour = () => {
  const { t } = useTranslation('commons')

  return (
    <Container
      className="d-flex flex-column align-items-center justify-content-center text-center"
      style={{ minHeight: '70vh' }}
    >
      <div className="four-o-four-number mb-4">
        404
      </div>
      <h1 className="four-o-four-title h2 mb-3">{t('fourOFour.title')}</h1>
      <p className="four-o-four-description mb-4">
        {t('fourOFour.description')}
      </p>
      <Button
        color="primary"
        onClick={() => history.push('/')}
        outline
      >
        {t('fourOFour.backHome')}
      </Button>
    </Container>
  )
}

export default FourOFour
